import React from 'react';
import { AccommodationPlacePartnerV2 } from './AccommodationPlacePartnerV2';

const AccommodationPlacePartner = (props: { accommodationPlaceV2ByIdId: string }) => {
  return (
    <>
      <AccommodationPlacePartnerV2 {...props} />
    </>
  );
};

export default AccommodationPlacePartner;
